import type { FaireProductEntity } from "../../entity_types/product";

export const p_nt4kbedrwa: FaireProductEntity = {
  token: "p_nt4kbedrwa",
  type: "product",
  name: "MUK LUKS Women's Slipper Sock/Cabin Sock Combo Assorted Bin",
  brandName: "Muk Luks",
  imageUrl:
    "https://cdn.faire.com/fastly/b94377eddcbd26f32aefb68b263ef29d106ea6ce80f81ce1299212ad891da500.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b9ad8784e38631ad2e069e178a0d73027f9feb48fff52c41b8551f53a110f530.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
